import { render, staticRenderFns } from "./AutoCheckControl.vue?vue&type=template&id=f3223bcc&scoped=true"
import script from "./AutoCheckControl.vue?vue&type=script&lang=js"
export * from "./AutoCheckControl.vue?vue&type=script&lang=js"
import "./AutoCheckControl.vue?vue&type=style&index=0&id=f3223bcc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3223bcc",
  null
  
)

export default component.exports